import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredQualityApprovals,
  selectQualityApprovalFilterVisible,
  selectQualityApprovalLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteQualityApproval, fetchQualityApprovalData } from './store/slice';
import { actions as qualityApprovalActions } from './store/slice';
import { format } from 'date-fns';

const { QUALITYAPPROVAL_ADD_EDIT } = MODAL_TYPES;
const { setSelectedPart } = qualityApprovalActions;
const QualityApprovalTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const inventoryTileRef = useRef(null);
  const filteredQualityApprovals = useSelector(selectFilteredQualityApprovals);
  const isLoading = useSelector(selectQualityApprovalLoading);
  const filterVisible = useSelector(selectQualityApprovalFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (inventoryTileRef.current) {
      const width = inventoryTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredQualityApprovals.map(qualityApproval => (
    <Tile qualityApproval={qualityApproval} />
  ));

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={inventoryTileRef}
    >
      {isLoading && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredQualityApprovals.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ qualityApproval }) => {
  console.log('QualityApproval itemData', qualityApproval);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(fetchQualityApprovalData(qualityApproval));
    dispatch(setSelectedPart(qualityApproval));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteQualityApproval(inventory.processId));
  };

  return (
    <div key={qualityApproval.qualityApprovalId || Math.random()} className="shipment-tile">
      <div
        className={`card p-3 m-2 ${qualityApproval.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">
                {qualityApproval.partNumber}
                {qualityApproval.isAlerts === 'Yes' && (
                  <span style={{ fontSize: '1.25rem' }}>⚠️</span>
                )}
              </h6>
              {qualityApproval.createdDate && (
                <div className="mt-1">
                  <small style={{ fontSize: '0.7rem', color: '#6c757d', fontWeight: 'normal' }}>
                    {format(new Date(qualityApproval.createdDate), 'dd-MMM-yyyy')}
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="mt-1 d-flex align-items-center gap-2 mb-2">
          {qualityApproval.isAlerts === 'Yes' && (
            <span
              className="badge"
              style={{
                backgroundColor: '#e0e0e0',
                color: '#000000',
              }}
            >
              Pending
            </span>
          )}
          <span className="badge" style={{ backgroundColor: '#957cf9', color: '#000000' }}>
            {qualityApproval.status || 'N/A'}
          </span>
        </div>
        <div className="tile-descriptionText">
          <span className="tile-description" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
            {qualityApproval.description}
          </span>
        </div>
      </div>
    </div>
  );
};

export default QualityApprovalTile;
